export const CREATE_GAME = 'CREATE_GAME';
export const CREATE_GAME_SUCCESS = 'CREATE_GAME_SUCCESS';
export const DELETE_GAME = 'DELETE_GAME';
export const GET_GAMES = 'GET_GAMES';
export const SET_GAMES = 'SET_GAMES';
